import axios from 'axios'
import * as inter from './interceptors'
import qs from 'qs'

export const CancelToken = axios.CancelToken
export const isCancel = axios.isCancel

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_DOMAIN,
  origin: process.env.VUE_APP_ORIGIN,
  withCredentials: true,
  paramsSerializer (params) {
    return qs.stringify(params, {
      strictNullHandling: true,
      skipNulls: true,
    })
  },
})
http.interceptors.request.use(
  config => {
    return config
  },
)
http.interceptors.response.use(inter.handleSuccess, inter.handleError)
http.interceptors.request.use(inter.useDatadog)

export default http
